/**
 * The NewMatchDetail class acts as the view object for the new match detail.
 */
const DateTimeFunc = require('@/tbs/util/DateTimeFunc')
const Address = require('@/tbs/model/mo/Address')
const NewMatchDetail = require('@/tbs/model/to/NewMatchDetail')
const locale = new NewMatchDetail
const tbs_model_vo_NewMatchDetail = function () {
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_NewMatchDetail.prototype = {
  /* The view object name */
  name: '',
  /* The view object instance */
  view: {
    get: [
      {
        name: 'matchTopInfo',
        baseUrl: process.env.VUE_APP_BANMA_API,
        apiPrefix: '/bmmatch/',
        service: 'GetBMUnionMatch',
        query: {
          unionMatchId: 'unionMatchId',
          preview: '(0)'
        },
        basePath: 'data.match',
        rule: {  // 转换规则
          id: 'id',
          name: 'chineseName',
          logoUrl: 'icon',
          address: '$province,city,district',  // 使用格式化方法动态拼接地址，函数名由 rulePropertyName (address) 生成 renderAddress
          totalPV: 'totalPV'
        }
      },
      {
        name: 'matchState',
        baseUrl: process.env.VUE_APP_BANMA_API,
        apiPrefix: '/bmmatch/',
        service: 'GetBMUnionMatch',
        query: {
          unionMatchId: 'unionMatchId',
          preview: '(0)'
        },
        basePath: 'data.match',
        rule: {
          status: '$regBeginDate,regEndDate',
          regUpdateEndDate: '$regUpdateEndDate',
        }
      },
      {
        name: 'tabsList',
        baseUrl: process.env.VUE_APP_BANMA_API,
        apiPrefix: '/bmmatch/',
        service: 'GetBMUnionMatch',
        query: {
          unionMatchId: 'unionMatchId',
          preview: '(0)'
        },
        basePath: 'data.match',
        rule: {
          tabsList: '$sportType',
        }
      },
      {
        name: '',
        baseUrl: process.env.VUE_APP_BANMA_API,
        apiPrefix: '/bmmatch/',
        service: 'ViewBMUnionMatch',
        query: {
          unionMatchId: 'unionMatchId'
        }
      }
    ],
  },
  //--------------------------------------------------
  // render methods (for get/query/manage operations)
  //--------------------------------------------------
  /**
   * 地址拼接，委托给 Address 业务模型，默认用 · 拼接
   * @param {string} province - 省
   * @param {string} city - 市
   * @param {string} district - 区
   * @param {string} [separator='·'] - 可选，拼接符号
   * @return {string}
   */
  renderAddress: function (province, city, district) {
    return Address.renderAddress(province, city, district, '·')
  },
  renderStatus: function (regBeginDate, regEndDate) {
    // 报名状态判断：
    // - 当前时间 < regBeginDate  => 报名开始前
    // - regBeginDate <= 当前时间 <= regEndDate => 报名中
    // - 当前时间 > regEndDate => 报名已结束
    if (!regBeginDate || !regEndDate) {
      return locale.localeProp('reg-status-1')
    }

    const now = new Date()
    const beginDate = new Date(regBeginDate)
    const endDate = new Date(regEndDate)

    // 兜底：日期解析失败时
    if (isNaN(beginDate.getTime()) || isNaN(endDate.getTime())) {
      return locale.localeProp('reg-status-1')
    }

    if (now < beginDate) {
      return locale.localeProp('reg-status-1')
    }
    if (now <= endDate) {
      return locale.localeProp('reg-status-2')
    }
    return locale.localeProp('reg-status-3')
  },
  renderRegUpdateEndDate: function (regUpdateEndDate) {
    return DateTimeFunc.formatFullDate(new Date(regUpdateEndDate), 'yyyy-mm-dd hh:mm')
  },
  renderTabsList: function (sportType) {
    if (sportType === 'xxxx') {
      return []
    } else {
      return [
        {
          id: 'home',
          name: locale.localeProp('home'),
        },
        {
          id: 'schedule',
          name: locale.localeProp('schedule'),
        },
        {
          id: 'ranking',
          name: locale.localeProp('ranking'),
        },
        {
          id: 'video',
          name: locale.localeProp('video'),
        },
        {
          id: 'team',
          name: locale.localeProp('team'),
        },
        {
          id: 'my',
          name: locale.localeProp('my'),
        },
      ]
    }
  }
}

module.exports = tbs_model_vo_NewMatchDetail
